import { Observable, throwError } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { AppConfig } from '../app.config'
import { CenterTimeAndDutyReportDates } from '../centers'
import { HttpAttachment } from './http-attachment'

@Injectable({
  providedIn: 'root',
})
export class TimeAndDutyReportService {
  constructor(private http: HttpClient, private appConfig: AppConfig, private toastr: ToastrService) {}

  getTimeAndDutyDates(): Observable<CenterTimeAndDutyReportDates[]> {
    const url = this.appConfig.config.server_api.time_and_duty_reports.get_dates
    return this.http
      .post<CenterTimeAndDutyReportDates[]>(url, {})
      .pipe(map((response) => response.map((report) => new CenterTimeAndDutyReportDates(report))))
  }

  getTimeAndDutyReportFile(centerId: number, date: string, userId: number | null = null): Observable<HttpAttachment> {
    const data: any = {
      center_id: String(centerId),
      date,
    }
    let url: string
    const { get_report_for_user, get_report_for_current_user } = this.appConfig.config.server_api.time_and_duty_reports
    if (userId) {
      data.user_id = String(userId)
      url = get_report_for_user
    } else {
      url = get_report_for_current_user
    }
    return this.http.post(url, data, { observe: 'response', responseType: 'text' }).pipe(
      map((res) => HttpAttachment.fromResponse(res)),
      catchError((error) => {
        this.toastr.error(error.error.message)
        return throwError(error)
      }),
    )
  }
}
